import { render, staticRenderFns } from "./DowelEnlargement.vue?vue&type=template&id=37228ead&"
import script from "./DowelEnlargement.vue?vue&type=script&lang=js&"
export * from "./DowelEnlargement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports